import { Box, Text, VStack } from '@chakra-ui/react';
import { NavBar } from 'components/NavBar';

type HeroSectionProps = {
  filter: React.ReactElement;
  heading: string;
  bgImage: string;
};
const HeroSection = ({ filter, heading, bgImage }: HeroSectionProps) => {
  return (
    <>
      <Box
        height={500}
        width='100%'
        backgroundImage={bgImage}
        backgroundRepeat='no-repeat'
        backgroundPosition='top'
        backgroundSize='cover'
        borderRadius='50'
      >
        <Box
          display='flex'
          justifyContent='center'
          alignItems='flex-start'
          height='100%'
          width='100%'
          background='linear-gradient(80.5deg, rgba(32, 2, 2, 0.53) -3.75%, rgba(82, 52, 59, 0.2226) 100.79%)'
          borderRadius='50px'
          padding='48px 60px'
        >
          <VStack>
            <NavBar />
            <Text
              fontSize='42px'
              fontWeight={700}
              color='#FEFEFE'
              marginTop='100px !important'
              marginBottom='40px !important'
            >
              {heading}
            </Text>
            {filter}
          </VStack>
        </Box>
      </Box>
    </>
  );
};

export { HeroSection };
